/** Boîte de réception et préférences des notifications (dans Mon compte). */
import { lazy } from 'react';
import type { AppRoute } from '../../app/route-types.js';
import { NotificationOpenRedirect } from './NotificationOpenRedirect.js';

const NotificationCenter = lazy(() => import('./NotificationCenter.js').then((m) => ({ default: m.NotificationCenter })));
const NotificationPreferencesPage = lazy(() =>
  import('./NotificationPreferencesPage.js').then((m) => ({ default: m.NotificationPreferencesPage })));

export const notificationsRoutes: AppRoute[] = [
  { path: '/notifications', element: <NotificationCenter /> },
  // Notification push touchée (public/sw-push.js) : renvoie vers l'élément concerné.
  { path: '/notifications/ouvrir', element: <NotificationOpenRedirect /> },
  { path: '/profil/compte/notifications', element: <NotificationPreferencesPage /> },
];
